<template>
  <v-layout row wrap align-center justify-center>
    <v-flex xs12>
      <v-container fluid grid-list-md>
        <p v-if="!hasNotifications">Нет уведомлений для отображения</p>
        <v-data-table
          v-if="hasNotifications"
          :items="notifications"
          :rows-per-page-items="rowsPerPageItems"
          :pagination.sync="pagination"
        >
          <template v-slot:headers="props">
            <tr>
              <th>Дата</th>
              <th>Сообщение</th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr>
              <td class="no-wrap">{{ getDateTime(props.item.timestamp) }}</td>
              <td v-html="props.item.description"></td>
            </tr>
          </template>
        </v-data-table>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import STORE from "@/store/STORE";
import {mapActions} from "vuex";

import { getDateTime } from '@/utils';

const getNotificationsListFunc = STORE.modules.notifications.actions.getNotificationsList;
const getNotificationsUnreadCountFunc = STORE.modules.notifications.actions.getNotificationsUnreadCount;
const makeAllNotificationsReadFunc = STORE.modules.notifications.actions.makeAllNotificationsRead;

export default {
  name: 'NotificationsIndex',
  data() {
    return {
      notifications: [],

      rowsPerPageItems: [
        10,
        { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 },
      ],
      pagination: {
        rowsPerPage: 10,
      },
    };
  },
  async mounted() {
    this.setRouteLoadingValue(true);
    try {
      let {all_list} = await this[getNotificationsListFunc]();
      this.notifications = all_list;
      await this[makeAllNotificationsReadFunc]();
      await this[getNotificationsUnreadCountFunc]();
    } catch (e) {
      console.error(e);
    } finally {
      this.setRouteLoadingValue(false);
    }
  },
  methods: {
    getDateTime,
    ...mapActions('notifications', [
      getNotificationsListFunc,
      getNotificationsUnreadCountFunc,
      makeAllNotificationsReadFunc
    ]),
  },
  computed: {
    hasNotifications() {
      return this.notifications.length > 0;
    }
  }
};
</script>
